var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox mall-default-setting-page" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _vm.checkPermi(["admin:system:config:info"])
            ? _c(
                "el-tabs",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  on: { "tab-click": _vm.handleTabClick },
                  model: {
                    value: _vm.activeNamel1,
                    callback: function ($$v) {
                      _vm.activeNamel1 = $$v
                    },
                    expression: "activeNamel1",
                  },
                },
                _vm._l(_vm.treeList, function (tab, index) {
                  return _c(
                    "el-tab-pane",
                    { key: index, attrs: { name: tab.id.toString() } },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "tab-label-stack",
                          attrs: { slot: "label" },
                          slot: "label",
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "tab-label-with-tag" },
                            [
                              _c("span", [_vm._v(_vm._s(tab.name))]),
                              _vm._v(" "),
                              _vm.l1IntegrityTag(tab).show
                                ? _c(
                                    "el-tag",
                                    {
                                      staticClass: "tab-integrity-tag",
                                      class: _vm.l1IntegrityTagClass(
                                        _vm.l1IntegrityTag(tab)
                                      ),
                                      attrs: { size: "mini" },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.l1IntegrityTag(tab).text) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.l1ConfigKeyText(tab)
                            ? _c("span", { staticClass: "tab-label-key" }, [
                                _vm._v(_vm._s(_vm.l1ConfigKeyText(tab))),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          tab.child.length > 0
                            ? _c(
                                "el-tabs",
                                {
                                  attrs: { type: "border-card" },
                                  on: { "tab-click": _vm.handleItemTabClick },
                                  model: {
                                    value: _vm.activeNamel2,
                                    callback: function ($$v) {
                                      _vm.activeNamel2 = $$v
                                    },
                                    expression: "activeNamel2",
                                  },
                                },
                                _vm._l(
                                  tab.child,
                                  function (tabItem, itemIndex) {
                                    return _c(
                                      "el-tab-pane",
                                      {
                                        key: itemIndex,
                                        attrs: { name: tabItem.extra },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "tab-label-stack",
                                            attrs: { slot: "label" },
                                            slot: "label",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "tab-label-with-tag",
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(tabItem.name)),
                                                ]),
                                                _vm._v(" "),
                                                _vm.formIntegrityTag(
                                                  tabItem.extra
                                                ).show
                                                  ? _c(
                                                      "el-tag",
                                                      {
                                                        staticClass:
                                                          "tab-integrity-tag",
                                                        class:
                                                          _vm.l1IntegrityTagClass(
                                                            _vm.formIntegrityTag(
                                                              tabItem.extra
                                                            )
                                                          ),
                                                        attrs: { size: "mini" },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.formIntegrityTag(
                                                                tabItem.extra
                                                              ).text
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.configKeyText(tabItem)
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "tab-label-key",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.configKeyText(
                                                          tabItem
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.integrityRow(tabItem.extra)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "integrity-toolbar",
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      size: "mini",
                                                      plain: "",
                                                      type: "primary",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openIntegrityDetail(
                                                          tabItem.extra,
                                                          "default"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "默认数据是否配置：" +
                                                        _vm._s(
                                                          _vm.yesNo(
                                                            _vm.integrityRow(
                                                              tabItem.extra
                                                            ).defaultComplete
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      size: "mini",
                                                      plain: "",
                                                      type: "primary",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openIntegrityDetail(
                                                          tabItem.extra,
                                                          "tenant"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "租户数据是否配置：" +
                                                        _vm._s(
                                                          _vm.yesNo(
                                                            _vm.integrityRow(
                                                              tabItem.extra
                                                            ).tenantComplete
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.showInitTenantButton(
                                                  tabItem.extra
                                                )
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          size: "mini",
                                                          type: "warning",
                                                          loading:
                                                            _vm.initTenantLoadingFor(
                                                              tabItem.extra
                                                            ),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleInitTenantFromDefault(
                                                              tabItem.extra
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("初始化租户数据")]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.onlyCanView
                                          ? _c(
                                              "p",
                                              { staticStyle: { color: "red" } },
                                              [
                                                _vm._v(
                                                  "此配置只能在客户的后台管理系统进行编辑"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.formConfChild.render
                                          ? _c("parser", {
                                              attrs: {
                                                "can-not-submit":
                                                  _vm.onlyCanView,
                                                "is-edit":
                                                  _vm.formConfChild.isEdit,
                                                "form-conf":
                                                  _vm.formConfChild.content,
                                                "form-edit-data":
                                                  _vm.currentEditData,
                                                "show-item-config-key": true,
                                                "tenant-field-issues":
                                                  _vm.tenantFieldIssuesForParser,
                                                "tenant-field-issue-highlight":
                                                  _vm.tenantFieldIssueHighlightForParser,
                                                "allow-field-tenant-init-button":
                                                  _vm.checkPermi([
                                                    "admin:system:config:save:form",
                                                  ]),
                                                "syncing-tenant-field-name":
                                                  _vm.syncingTenantFieldName,
                                              },
                                              on: {
                                                "field-tenant-init":
                                                  _vm.handleFieldTenantInit,
                                                submit: _vm.handlerSubmit,
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              )
                            : _c(
                                "span",
                                [
                                  _vm.integrityRow(tab.extra)
                                    ? _c(
                                        "div",
                                        { staticClass: "integrity-toolbar" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                plain: "",
                                                type: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openIntegrityDetail(
                                                    tab.extra,
                                                    "default"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "默认数据是否配置：" +
                                                  _vm._s(
                                                    _vm.yesNo(
                                                      _vm.integrityRow(
                                                        tab.extra
                                                      ).defaultComplete
                                                    )
                                                  )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                plain: "",
                                                type: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openIntegrityDetail(
                                                    tab.extra,
                                                    "tenant"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "租户数据是否配置：" +
                                                  _vm._s(
                                                    _vm.yesNo(
                                                      _vm.integrityRow(
                                                        tab.extra
                                                      ).tenantComplete
                                                    )
                                                  )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.showInitTenantButton(tab.extra)
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    type: "warning",
                                                    loading:
                                                      _vm.initTenantLoadingFor(
                                                        tab.extra
                                                      ),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleInitTenantFromDefault(
                                                        tab.extra
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("初始化租户数据")]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.formConf.render
                                    ? _c("parser", {
                                        attrs: {
                                          "can-not-submit": _vm.onlyCanView,
                                          "is-edit": _vm.formConf.isEdit,
                                          "form-conf": _vm.formConf.content,
                                          "form-edit-data": _vm.currentEditData,
                                          "show-item-config-key": true,
                                          "tenant-field-issues":
                                            _vm.tenantFieldIssuesForParser,
                                          "tenant-field-issue-highlight":
                                            _vm.tenantFieldIssueHighlightForParser,
                                          "allow-field-tenant-init-button":
                                            _vm.checkPermi([
                                              "admin:system:config:save:form",
                                            ]),
                                          "syncing-tenant-field-name":
                                            _vm.syncingTenantFieldName,
                                        },
                                        on: {
                                          "field-tenant-init":
                                            _vm.handleFieldTenantInit,
                                          submit: _vm.handlerSubmit,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.tenantIssueDialogTitle,
            visible: _vm.tenantIssueDialogVisible,
            width: "760px",
            "append-to-body": "",
            "custom-class": "tenant-integrity-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.tenantIssueDialogVisible = $event
            },
            close: function ($event) {
              _vm.tenantIssueTableRows = []
            },
          },
        },
        [
          _vm.tenantIssueTableRows.length
            ? _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tenantIssueTableRows,
                    border: "",
                    size: "small",
                    "max-height": "460",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "fieldName",
                      label: "配置字段",
                      width: "160",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "tenantName",
                      label: "租户",
                      width: "200",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "tenantId", label: "租户ID", width: "100" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "issue",
                      label: "问题说明",
                      "min-width": "220",
                      "show-overflow-tooltip": "",
                    },
                  }),
                ],
                1
              )
            : _c("div", { staticClass: "tenant-issue-dialog-fallback" }, [
                _vm._v(_vm._s(_vm.tenantIssueDialogEmptyText)),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }